<template>
    <div class="vld-parent">
        <loading 
            :active="isLoad" 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage">
        </loading>
        
    </div>
</template>

<script>
// Import component
import * as types from '@/store/mutation-types'
import Loading from 'vue-loading-overlay';
import { mapGetters } from 'vuex'

// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
    data() {
        return {
            fullPage: true
        }
    },
    components: {
        Loading
    },
    methods: {
        doAjax() {
            // this.isLoading = true;
            // // simulate AJAX
            // setTimeout(() => {
            //     this.isLoading = false
            // }, 5000)
        },
        onCancel() {
            console.log('User cancelled the loader.')
        }
    },
    computed: {
        isLoad() {
            return this.$store.getters.showLoading;
        }
    }
    // computed: mapGetters({
    //     isLoad: types.SHOW_LOADING
    // }),
}
</script>